import {stage} from './stage';

type ConfigShape = {
    [key in 'prod' | 'test' | 'dev' | 'ide']: {
        enabled: boolean;
        policyStoreId: string;
        region: string;
        namespace?: string;
    };
};

const config: ConfigShape = {
    prod: {
        enabled: true,
        policyStoreId: 'VaQogcgqzCzf8WBbp9jtQt',
        region: 'us-west-2',
        namespace: 'FlexiBot',
    },
    test: {
        enabled: true,
        policyStoreId: 'UhVMhe1wRWv99hvdSBSgMB',
        region: 'us-west-2',
        namespace: 'FlexiBot',
    },
    dev: {
        enabled: true,
        policyStoreId: 'NZMyWFoGEGsqYusxCrCjyB',
        region: 'us-west-2',
        namespace: 'FlexiBot',
    },
    ide: {
        enabled: true,
        policyStoreId: 'NZMyWFoGEGsqYusxCrCjyB',
        region: 'us-west-2',
        namespace: 'FlexiBot',
    },
};

export default config[stage];
